exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "last-day-alert{display:block}last-day-alert .card{display:inline-flex;width:327px;max-height:48px;background-color:#fff;box-shadow:0 0 8px 3px hsla(220,8%,92%,.5);border-radius:3px}last-day-alert .message-container{padding:7px 5px 0}last-day-alert .alert-message{font-family:Stag Sans;font-size:14px;font-weight:300;line-height:1.21;text-align:left;color:#666}last-day-alert .vertical-bar-left{margin-right:10px;width:10px;height:48px;border:1px #fff;border-top-left-radius:3px;border-bottom-left-radius:3px;background-color:#52bcec}@media(max-width:944px){last-day-alert .vertical-bar-left{margin-right:5px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/lastDayAlert/lastDayAlert.scss
// module id = 1688
// module chunks = 0